import WebHeader from '@shared/components/core/headers/WebHeader';
import { ContentWrapper } from '@shared/components/core/structure/CommonBodyLayoutStyles';
import SidebarLayout from '@shared/components/core/structure/SidebarLayout';
import TosAcceptanceDialog from '@shared/components/tos/TosAcceptanceDialog';
import CurrentUserContainer from '@shared/hooks/state/CurrentUserContainer';
import { useAdminInitializeData } from 'admin/hooks/useAdminInitializeData';
import useAdminMenuItems from 'admin/hooks/useAdminMenuItems';
import { Outlet, useParams } from 'react-router';

export default function AdminSidebarLayout() {
    const { isLoading } = useAdminInitializeData();
    const { topItems, bottomItems } = useAdminMenuItems();
    const { managedOrgId } = useParams();
    const { pendingTosConfig, setPendingTosConfig } = CurrentUserContainer.useContainer();

    return (
        <SidebarLayout
            isLoading={isLoading}
            headerContent={<WebHeader />}
            topItems={topItems}
            bottomItems={bottomItems}
            managed={!!managedOrgId}>
            <ContentWrapper>
                <Outlet />
                {pendingTosConfig && (
                    <TosAcceptanceDialog
                        open={true}
                        tosConfig={pendingTosConfig}
                        onAccepted={() => setPendingTosConfig(null)}
                    />
                )}
            </ContentWrapper>
        </SidebarLayout>
    );
}
